import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export default function ThirdPartySeparator(): ReactElement {
  const { t } = useTranslation('auth')

  return (<div className='font-sans text-center text-base text-black dark:text-white'>{t('label.separator')}</div>)
}